export const anakiwa = '#95c7ff';
export const cocoaBean = '#492020';
export const feijoa = '#a7d48d';
export const greenKelp = '#36492A';
export const mauvelous = '#f29090';
export const tundora = '#404040';
export const wildSand = '#F6F6F6';
export const froly = '#f07a7b';
